import cpluspluslogo from "./cpluspluslogo.png";
import javascript from "./javascript.png";
import python from "./python.png";
import html from "./html.png";
import css from "./css3.png";
import solidity from "./solidity.png";
import react from "./react.png";
import tailwind from "./tailwind.png";
import node from "./nodejs.png";
import express from "./express.png";
import figma from "./figma.png";
import git from "./git.png";
import postgresql from "./postgreesql.png";
import vercel from "./vercel.png";
import mongodb from "./mongodb.png";
import firebase from "./firebase.png";
import docker from "./docker.png";
import socketio from "./socketio.png";
import nextjs from "./nextjs.png";
import hardhat from "./hardhat.webp";
import sass from "./sass.png";
import bootstrap from "./bootstrap.png";
import flask from "./flask.png";
import hyperledger from "./hyperledger.png";
import postman from "./postman.png";
import linux from "./linux.png";
import gcp from "./gcp.png";
import markdown from "./markdown.png";
import npm from "./npm.png";
import storybook from "./storybook.png";
import prisma from "./prisma.png";

export const techStackIcons = [
    { name: "C++", img: cpluspluslogo, alt: "cpp" },
    { name: "JavaScript", img: javascript, alt: "js" },
    { name: "Python", img: python, alt: "python" },
    { name: "HTML", img: html, alt: "html" },
    { name: "CSS", img: css, alt: "css" },
    { name: "Solidity", img: solidity, alt: "solidity" },
    { name: "React", img: react, alt: "react" },
    { name: "Tailwind", img: tailwind, alt: "tailwind" },
    { name: "Node.js", img: node, alt: "node" },
    { name: "Express", img: express, alt: "express" },
    { name: "Figma", img: figma, alt: "figma" },
    { name: "Git", img: git, alt: "git" },
    { name: "PostgreSQL", img: postgresql, alt: "postgresql" },
    { name: "Prisma", img: prisma, alt: "prisma" },
    // { name: "Vercel", img: vercel, alt: "vercel" },
    { name: "MongoDB", img: mongodb, alt: "mongodb" },
    { name: "Firebase", img: firebase, alt: "firebase" },
    { name: "Docker", img: docker, alt: "docker" },
    { name: "Socket.io", img: socketio, alt: "socketio" },
    { name: "Next.js", img: nextjs, alt: "nextjs" },
    { name: "Hardhat", img: hardhat, alt: "hardhat" },
    { name: "Sass", img: sass, alt: "sass" },
    // { name: "Bootstrap", img: bootstrap, alt: "bootstrap" },
    { name: "Flask", img: flask, alt: "flask" },
    { name: "Hyperledger", img: hyperledger, alt: "hyperledger" },
    { name: "Postman", img: postman, alt: "postman" },
    { name: "Linux", img: linux, alt: "linux" },
    { name: "Google Cloud Platform", img: gcp, alt: "gcp" },
    { name: "Markdown", img: markdown, alt: "markdown" },
    { name: "NPM", img: npm, alt: "npm" },
    { name: "Storybook", img: storybook, alt: "storybook" },
];